<template>
    <div>
        <!-- 搜索 -->
        <search :typeAutocomplete="listData" :search="true" :type="'UserManagement'" @add-data="add_data" @search-data="search_data" @Export="Export"></search>
        <!-- 列表 -->
        <tables id="table-box"  :tableData="tableData" :tableLabel="tableLabel" :ifheader="false" :Calculate="false" @event-button="event_button" ></tables>
        <!-- 新增用户 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="New_User" :title="title"  :width="'720px'" v-if="New_User">
            <NewUser :visibles.sync="New_User" @Render="Render" :type="type" :row="row"></NewUser>
        </el-dialog>
        <!-- 关联角色 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="New_Associated_User" :title="title"  :width="'720px'" v-if="New_Associated_User">
            <AssociatedUser :visibles.sync="New_Associated_User" @Render="Render" :type="type" :row="row"></AssociatedUser>
        </el-dialog>
      <!-- 重置密码 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="rePassword" :title="title" :width="'720px'" v-if="rePassword">
          <RePassword :visibles.sync="rePassword" @Render="Render" :type="type" :row="row"></RePassword>
        </el-dialog>
         <!-- 分页 -->
        <pagination
            v-show="(Number(total) > 0)"
            :total="Number(total)"
            :page.sync="matterParams.current"
            :limit.sync="matterParams.size"
            @pagination="Render"
        />
    </div>
</template>

<script>
import NewUser from '../dialog/NewUser'
import AssociatedUser from '../dialog/AssociatedUser'
import RePassword from '../dialog/RePassword'
export default {
  components: {
    RePassword,
    NewUser,
    AssociatedUser
  },
  // props: {
  // '': {
  //    type:Object|Array|String|Boolean|Number
  //  }
  // },
  data () {
    return {
      New_Associated_User: false,
      rePassword: false,
      New_User: false,
      title: '',
      total: 0,
      type: '',
      row: {},
      listData: [],
      matterParams: {
        // 默认显示页数
        current: 1,
        // 一页几条数据
        size: 10,
        // orders: 'gmtCreate|desc,id|desc'
        orders: 'id|desc'
      },
      tableData: [
      ],
      tableLabel: [
        { label: '序号', width: '80', prop: 'index', align: 'center' },
        { label: '用户名称', width: '', prop: 'account', align: 'center' },
        { label: '所属部门', width: '', prop: 'deptName', align: 'center' },
        { label: '统一社会信用代码', width: '', prop: 'uscCode', align: 'center' },
        {
          label: '操作',
          width: '400',
          align: 'center',
          isOpera: true, // 判断是否生成按钮
          titleList: [
            { title: '分配角色', status: 'primary' },
            { title: '修改', status: 'primary' },
            { title: '删除', status: 'primary' },
            { title: '重置密码', status: 'primary' }
          ]
        }
      ]
    }
  },
  methods: {
    // 新增
    add_data (v) {
      this.title = '新增用户'
      this.New_User = true
      this.type = 'add'
      this.row = {}
    },
    // 所属部门
    departmentRemoteMethod (query) {
      this.loading = true
      setTimeout(() => {
        this.departmentList = this.$Layoutfun.ProcessingData(query, this.$department.list(), 'name')
        this.loading = false
      }, 300)
    },
    // 下拉框事件改变
    ChangeSelectFun (event) {
      if (!event) {
        this.departmentRemoteMethod(event)
      }
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1
      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 导出
    Export () {
    //   this.tableLabel[8].ifshow = true
      setTimeout(() => {
        this.$tableToExcel('#table-box .el-table', '用户信息.xlsx')
        // this.tableLabel[8].ifshow = false
      })
      this.$message.success('导出成功')
    },
    // 列表按钮
    event_button (type, row) {
      if (type === '修改') {
        this.New_User = true
        this.title = '修改用户'
        this.type = 'edit'
        this.row = row
      } else if (type === '删除') {
        this.$confirm(`此操作将永久删除${row.account}该用户, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.Delete('/ucenter/user/deleteGovUser', { id: row.id }).then((res) => {
            this.$message.success('删除成功')
            this.Render()
          })
        }).catch(() => {})
      } else if (type === '分配角色') {
        this.New_Associated_User = true
        this.title = '分配角色'
        this.row = row
      } else if (type === '重置密码') {
        this.rePassword = true
        this.title = '重置密码'
        this.row = row
      }
    },
    // 列表数据
    Render () {
      this.$http.get('/ucenter/user/queryGovUserPage', this.matterParams).then((res) => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
    }
  },
  created () {
    this.Render()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>

</style>
